export function cleanCpf(value) {
  return String(value || '').replace(/\D/g, '')
}

// Brazilian CPF: 11 digits, the last two are mod-11 check digits.
export function isValidCpf(value) {
  const cpf = cleanCpf(value)
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false
  const digits = cpf.split('').map(Number)
  for (const len of [9, 10]) {
    let sum = 0
    for (let i = 0; i < len; i++) sum += digits[i] * (len + 1 - i)
    const check = (sum * 10) % 11 % 10
    if (check !== digits[len]) return false
  }
  return true
}

export function formatCpf(value) {
  const cpf = cleanCpf(value)
  if (cpf.length !== 11) return cpf
  return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9)}`
}

// The driver's CPF is stored in the driver notes (labelled "CPF" in pt locales).
export function driverCpf(driver) {
  const cpf = cleanCpf(driver && driver.attributes && driver.attributes.notes)
  return isValidCpf(cpf) ? cpf : null
}
